// Custom cart drawer. Section Rendering API for live updates.
(function () {
  var SECTION_ID = 'cart-drawer-mm';
  var SELECTOR = '.mm-cd';

  function open() {
    document.querySelectorAll('.mm-cd, .mm-cd-overlay').forEach(function (el) {
      el.classList.add('is-open');
      el.removeAttribute('inert');
    });
  }
  function close() {
    document.querySelectorAll('.mm-cd, .mm-cd-overlay').forEach(function (el) {
      el.classList.remove('is-open');
    });
    var panel = document.querySelector('.mm-cd');
    if (panel) panel.setAttribute('inert', '');
  }

  // Header-button + any [data-cart-open] triggers, plus close handling.
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) {
      e.preventDefault();
      open();
      return;
    }

    var panel = document.querySelector('.mm-cd');
    if (!panel || !panel.classList.contains('is-open')) return;
    // Ignore clicks while the drawer is updating (prevents a second click during
    // the re-render from falling through and closing the drawer).
    if (panel.getAttribute('aria-busy') === 'true') return;

    var closer = e.target.closest('[data-cart-close]');
    if (closer) {
      // Real links (product thumb/title, browse) should still navigate — just
      // close the drawer visually and let the click proceed.
      if (closer.tagName === 'A' && closer.getAttribute('href')) {
        close();
        return;
      }
      e.preventDefault();
      close();
      return;
    }

    // Click landed outside the panel (the page behind it) → close.
    if (!e.target.closest('.mm-cd')) {
      close();
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && document.querySelector('.mm-cd.is-open')) close();
  });

  function refresh() {
    var d = document.querySelector(SELECTOR);
    if (d) d.setAttribute('aria-busy', 'true');
    return fetch('/?sections=' + SECTION_ID, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data[SECTION_ID];
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html.trim();
        var nextSection = tmp.querySelector('#shopify-section-' + SECTION_ID) || tmp.firstElementChild;
        var current = document.getElementById('shopify-section-' + SECTION_ID);
        if (nextSection && current) {
          var wasOpen = !!document.querySelector('.mm-cd.is-open');
          current.innerHTML = nextSection.innerHTML;
          // The freshly-rendered panel comes back with the `inert` attribute and
          // without `is-open`; re-open() restores both so it stays interactive.
          if (wasOpen) open();
        }
      })
      .finally(function () {
        var d2 = document.querySelector(SELECTOR);
        if (d2) d2.removeAttribute('aria-busy');
        updateBubble();
      });
  }

  function updateBubble() {
    // Refresh header cart count from /cart.js
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var bubble = document.querySelector('.mm-header__cart-count');
        var btn = document.querySelector('.mm-header__cart');
        if (c.item_count > 0) {
          if (!bubble && btn) {
            bubble = document.createElement('span');
            bubble.className = 'mm-header__cart-count';
            bubble.setAttribute('aria-hidden', 'true');
            btn.appendChild(bubble);
          }
          if (bubble) bubble.textContent = c.item_count;
        } else if (bubble) {
          bubble.remove();
        }
      })
      .catch(function () {});
  }

  // Delegated handlers for line items / upsells / quantity
  document.addEventListener('click', function (e) {
    // Ignore while a previous update is still in flight.
    var busyPanel = document.querySelector('.mm-cd');
    if (busyPanel && busyPanel.getAttribute('aria-busy') === 'true') return;
    var step = e.target.closest('[data-cd-step]');
    if (step) {
      e.preventDefault();
      var key = step.getAttribute('data-cd-step');
      var dir = step.getAttribute('data-cd-dir');
      var qtyEl = document.querySelector('[data-cd-qty="' + CSS.escape(key) + '"]');
      var current = qtyEl ? parseInt(qtyEl.textContent.trim(), 10) : 1;
      // Digital store: quantity is capped at 1, so "+" never goes above 1.
      var next = dir === 'inc' ? Math.min(1, current + 1) : Math.max(0, current - 1);
      if (next === current) return;
      changeQty(key, next);
      return;
    }
    var rm = e.target.closest('[data-cd-remove]');
    if (rm) {
      e.preventDefault();
      changeQty(rm.getAttribute('data-cd-remove'), 0);
      return;
    }
    var add = e.target.closest('[data-cd-add]');
    if (add) {
      e.preventDefault();
      addToCart(add.getAttribute('data-cd-add'), add);
    }
  });

  function changeQty(key, qty) {
    if (!key) return;
    var d = document.querySelector(SELECTOR);
    if (d) d.setAttribute('aria-busy', 'true');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function () { return refresh(); })
      .catch(function () {
        var d2 = document.querySelector(SELECTOR);
        if (d2) d2.removeAttribute('aria-busy');
      });
  }

  // Digital store: a product may only ever appear ONCE, quantity 1. After any
  // add this collapses the cart - caps every line to 1 and drops duplicate
  // lines of the same product - so bundles that include something already in
  // the cart can never create a second copy or a quantity of 2.
  function capCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.items) return;
        var seen = {};
        var ops = [];
        cart.items.forEach(function (it) {
          var pid = it.product_id;
          if (seen[pid]) {
            ops.push({ id: it.key, quantity: 0 });        // duplicate product -> remove
          } else {
            seen[pid] = true;
            if (it.quantity > 1) ops.push({ id: it.key, quantity: 1 }); // cap to 1
          }
        });
        if (!ops.length) return;
        return ops.reduce(function (p, op) {
          return p.then(function () {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              credentials: 'same-origin',
              body: JSON.stringify(op)
            });
          });
        }, Promise.resolve());
      })
      .catch(function () {});
  }

  function addToCart(variantId, btn) {
    if (!variantId) return;
    if (btn) btn.setAttribute('disabled', 'true');
    var payload = { id: variantId, quantity: 1 };
    // Subscription products (e.g. the Vault) must carry their selling plan.
    var plan = btn && btn.getAttribute('data-cd-plan');
    if (plan) payload.selling_plan = plan;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    })
      .then(function () { return capCart(); })
      .then(function () { return refresh(); })
      .then(function () {
        open();
        if (btn) btn.removeAttribute('disabled');
      })
      .catch(function () {
        if (btn) btn.removeAttribute('disabled');
      });
  }

  // Intercept any add-to-cart form submit -> AJAX add -> open drawer.
  // Robust match: catches /cart/add, /cart/add.js, locale-prefixed paths,
  // absolute or relative actions.
  function isCartAddForm(form) {
    if (!form || form.tagName !== 'FORM') return false;
    var action = form.getAttribute('action') || form.action || '';
    return /\/cart\/add(\b|\.js|$|\?)/.test(action);
  }
  // Show an add-to-cart error next to the form that caused it (e.g. Shopify's
  // "requires a selling plan" 422) instead of pretending the add worked.
  function showFormError(form, message) {
    var el = form.querySelector('.mm-add-error');
    if (!el) {
      el = document.createElement('p');
      el.className = 'mm-add-error';
      el.setAttribute('role', 'alert');
      el.style.cssText = 'margin:10px 0 0;font-size:15px;font-weight:600;color:#ff6b6b;flex-basis:100%;';
      form.appendChild(el);
    }
    el.textContent = message;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!isCartAddForm(form)) return;
    e.preventDefault();
    var fd = new FormData(form);
    var btn = form.querySelector('button[type=submit], [name=add]');
    if (btn) btn.setAttribute('disabled', 'true');
    // Forms containing a [data-mm-checkout] marker add the item then go straight
    // to checkout instead of opening the drawer.
    var toCheckout = !!form.querySelector('[data-mm-checkout]');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: fd
    })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (data) {
          return { ok: r.ok, data: data };
        });
      })
      .then(function (res) {
        if (!res.ok) {
          // The add FAILED (sold out, selling plan required, …). Never proceed
          // to checkout with a cart that doesn't have the item - that's what
          // made the button look like it "cancels checkout" and bounced empty
          // carts back to the homepage.
          var d = res.data || {};
          var msg = typeof d.description === 'string' && d.description ? d.description
                  : typeof d.message === 'string' && d.message ? d.message
                  : 'Sorry, this item could not be added to the cart. Please try again.';
          showFormError(form, msg);
          if (btn) btn.removeAttribute('disabled');
          return;
        }
        // Collapse duplicates / cap to 1 FIRST, so checkout never receives a
        // second copy of something already in the cart, and the drawer shows
        // the correct single line.
        return capCart().then(function () {
          if (toCheckout) { window.location.href = '/checkout'; return; }
          return refresh().then(open).then(function () {
            if (btn) btn.removeAttribute('disabled');
          });
        });
      })
      .catch(function () {
        showFormError(form, 'Sorry, something went wrong. Please try again.');
        if (btn) btn.removeAttribute('disabled');
      });
  });
})();
